import script from "./DocumentsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentsTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__